import styled from 'styled-components';
import {
  ProductiveHeading05,
  ProductiveHeading04,
  TextWrapper,
  ProductiveHeading03,
} from 'ozone/atoms/typography';

export const UnpaddedTextWrapper = styled(TextWrapper).attrs({
  as: 'p',
})`
  padding: 0;
`;

export const Heading = styled(ProductiveHeading05).attrs({
  as: UnpaddedTextWrapper,
})``;

export const SubHeading = styled(ProductiveHeading04).attrs({
  as: UnpaddedTextWrapper,
})``;

export const SubHeading2 = styled(ProductiveHeading03).attrs({
  as: UnpaddedTextWrapper,
})``;
